var lcssafira = lcssafira ||  {};
lcssafira.form = lcssafira.form || {};

;(function(namespace, $){

    function ValidateForm(form_id, datatype) {
      var selected_form = $('#' + form_id);

      if(datatype == '' || typeof datatype === 'undefined') {
        datatype = 'json';
      }

      selected_form.validate({
        // rules: {
        //   cel: {
        //     require_from_group: [1, ".phone-group"]
        //   },
        //   tel: {
        //     require_from_group: [1, ".phone-group"]
        //   }
        // },
        ignore : [],
        invalidHandler: function(event, validator) {

          var error,
              table_panel;
          
          error = validator.errorList[0].element.id;
        },
        submitHandler: function(form) {

            $(form).ajaxSubmit({
                success: onFormSuccess,
                beforeSubmit: function(arr, form, options) {
                  beforeSubmitForm(arr, form, options);
                },
                error: OnErrorAfterSubmit,
                dataType: datatype
            });
         }
       });

      $.extend(jQuery.validator.messages, {
          required: "Este campo deve ser preenchido.",
          email: "Forneça um endereço válido",
          extension: "Tipo de arquivo não permitido",
          max: "Forneça valor menor ou igual a 0",
          min: "Forneça valor maior ou igual a 0",
          require_from_group: 'Preencha um dos telefones'
      });
    }

    function beforeSubmitForm(arr, form, options) {
      
      var form_id = form.attr('id');
      togglePreload(form_id);
      $("button[type='submit']").attr('disabled', true);
    }

    function onFormSuccess(responseText, statusText, xhr, form) {

      $("button[type='submit']").attr('disabled', false);

      var form_id,
          btn_print_cadastro,
          btn_cadastra_pcc,
          btn_voltar_pcc,
          table_consulta;

      form_id = form.attr('id');
      btn_print_cadastro = $('#btn-print-cadastro');
      btn_cadastra_pcc = $('#btn-cadastra-pcc');
      btn_voltar_pcc = $('#btn-voltar-pcc');
      reset_after_submit = form.attr('data-reset');

      togglePreload(form_id);

      if(!form.hasClass('form-cadastro')) {

       
      }
      else {

        if(responseText.status == 1 || responseText == 1 || responseText.status) {
            btn_cadastra_pcc.hide();
            toogleFeedBack('<span class="glyphicon glyphicon-ok"></span> Cadastro realizado', form_id, true);
            btn_print_cadastro.attr('href','/pcc/imprimir/' + responseText.lastPccId);
            btn_print_cadastro.show();
            btn_voltar_pcc.show();


          if(reset_after_submit === 'true') {
            $('#' + form_id)[0].reset();
          }
        }

        else if(responseText == 23000 || responseText.status == 23000) {
          toogleFeedBack('<span class="glyphicon glyphicon-remove"></span> Registro não adicionado. Motivo: Cadastro duplicado', form_id, true);
        }

        else {
          toogleFeedBack('<span class="glyphicon glyphicon-remove"></span> Não foi possível cadastrar', form_id, true);
        }
      }
    }

    function OnErrorAfterSubmit(data) {

      var message = {
        codigo : 0,
        mensagem : data.responseText
      };

      togglePreload('');
      modal_msg = new lcssafira.confirmmodal.ConfirmModal('', message, 'alert');
      $("button[type='submit']").attr('disabled', false);
    }

    // function OnErrorAfterSubmit(data) {

    //   var message = {};

    //   $.each(data.responseJSON, function(index, val) {
    //      message.codigo = '';
    //      message.mensagem += val + '<br>';
    //   });

    //   togglePreload('');
    //   modal_msg = new lcssafira.confirmmodal.ConfirmModal('', message, 'alert');
    //   $("button[type='submit']").attr('disabled', false);
    // }

    function togglePreload(form_id) {

      var holder_loader;

      if(form_id == '') {
        holder_loader = $('.preloader-holder');
      }
      else {
        holder_loader = $('#' + form_id + ' .preloader-holder');
      }
      
      if(form_id == 'form-nota') {
        holder_loader = $('.preloader-holder');
      }

      holder_loader.toggleClass('hide');

      //setTimeout(function(){  window.location.href = '/dashboard'; }, 2000);
     
    }

    function toogleFeedBack(message, form_id, visible) {

      var feed_holder;

      if(form_id != '') {
        feed_holder = $('#' + form_id + ' .feed-holder');
      }
      else {
        feed_holder = $('.feed-holder');
      }

      if(visible) {
        feed_holder.show().fadeOut(5000);
      }
      else {
        feed_holder.addClass('hide');
      }

      feed_holder.html(message);
    }

    function _construct() {
    }

    _construct();

   namespace.ValidateForm = ValidateForm;
    
})(lcssafira.form, jQuery);
